import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./starbucks_concept.js";
//#region src/starbucks_concept_helper.ts
var starbucks_concept_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(concept) {
	switch (concept) {
		case "airport": return "Airport";
		case "grocery": return "Grocery";
		case "college": return "College";
	}
}
//#endregion
export { name, starbucks_concept_helper_exports };

//# sourceMappingURL=starbucks_concept_helper.js.map